<template>
  <transition name="fade">
    <div v-if="popup">
      <div class="pop-up-bg" @click.prevent="$emit('close')"></div>
      <div class="pop-up">
        <a class="pop-up__close icon icon-close" @click.prevent="$emit('close')"></a>
        <h2 
          v-if="$root.app !== 'SoftProCrmAppRioTransTest' && $root.app !== 'SoftProCrmAppRioTrans'"
        >
          {{$root.langText.changes.container}}</h2>
        <h2 v-else>{{$root.langText.changes.carType}}</h2>
        <Search :filterNone="'none'" @inputchange="searchBtn"/>
        <p class="list-not" v-if="listNot">{{$root.langText.notFound}}</p>
        <ul class="pop-up__list">
          <li
            v-for="(person, index) in carType"
            :key="index"
            :data-id="person.id"
            @click.prevent="$emit('close', {id: person.id, name: person.name})"
          >
            <div class="pop-up__list__row">
              {{person.name}}
            </div>
            <div class="decor-line"></div>
          </li>
        </ul>
        <Pagination v-if="quantityList && quantityList > params.limit" @pagination="pagination" :dataList="{quantityList, params}"/>
      </div>
    </div>
  </transition>
</template>


<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }

</style>


<script>
import Pagination from "@/components/app/Pagination"
import Search from "@/components/app/Search"

export default {
  props: ['popup'],

  data:() => ({
    carType: [],
    quantityList: '',
    //pagination
    params: {
      start: 0, 
      limit: 20,
    },
    arrFilters: '',
    listNot: false
    
  }),
  async mounted() {
    //base
    const CarTypeApi = await this.$store.dispatch('getCarType', this.params);
    this.carType = CarTypeApi.data.list;
    this.quantityList = CarTypeApi.data.total_num
  },
  methods: {

    //function filtration
    async reloadFilters(mod){
      if(mod !== 'pagination'){
        this.params.start = 0
      }
      this.arrFilters = this.searchData
      var arrFilters = await this.$store.dispatch('postFiltersCarType', {params: this.params, data: this.arrFilters})
      this.carType = arrFilters.data.list
      this.quantityList = arrFilters.data.total_num
      if(this.quantityList == 0){
        this.listNot = true
      } else{
        this.listNot = false
      }
    },


    //search
    async searchBtn(data) {
      if(data !== undefined && data.load !== true){
        this.searchData = data.search
      }
      if(data.load !== true){
        this.reloadFilters('search');
      }
    },

    //paginations
    async pagination(data){
      this.params.start = data.start
      if(data.load !== true){
        this.reloadFilters('pagination')
      }
    }


  },
  components:{
    Pagination, Search
  }
  
}
</script>